export const MENU_BAR_ID = "menu-bar";
export const SYSTEM_BAR_ID = "system-bar";
